import { Component, Inject, Watch, Vue, Prop } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  ICON_LIST_FIXED,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { Http } from "@status/codes";
import AddFieldGroup from "@/shared/components/AddFieldGroup/AddFieldGroup.vue";
import {
  INFO_GROUP_CONSTANTS,
  FIELD_GROUP_CONSTANTS,
  INFO_GROUPS_ACCESS
} from "../../constants/InfoGroupConstants";
import { InfoGroupService } from "../../services/InfoGroupService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FullSchema } from "@/shared/models/FullSchema";
import { GroupFullSchema } from "../../models/GroupFullSchema";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { TYPE_FIELDS } from "@/shared/constants/FormConstants";
import { Utils } from "@/shared/utils/utils";
import { ManagedListsService } from "@/shared/services/ManagedListsService";
import {
  GENERAL_CONSTANTS,
  MANAGED_LISTS_TYPES,
  PANEL_INFO_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Icon } from "@/shared/models/Icon";
import SchemaVisualization from "../SchemaVisualization/SchemaVisualization.vue";
import Vuetify from "vuetify";
import { InfoGroupModel } from "../../models/InfoGroup";
import SaveList from "../../../List/components/SaveList/SaveList.vue";
import {
  FULL_SCHEMA_INITIALIZATION,
  GROUP_SCHEMA_INITIALIZATION,
  SAVE_INFO_GROUP_EVENTS
} from "./constants/SaveInfoGroupConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { AxiosError } from "axios";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { InfoGroupForm } from "../../models/InfoGroupForm.model";

Vue.use(Vuetify);
@Component({
  name: "SaveInfoGroup",
  components: {
    ModalTemplate,
    AddFieldGroup,
    FormModalViewer,
    SchemaVisualization,
    SaveList
  }
})
export default class SaveInfoGroup extends Vue {
  @Prop({ default: false }) isEditingInfoGroup!: boolean;
  @Prop({ default: 0 }) updateEditing!: number;
  @Prop() editingInfoGroup!: InfoGroupModel;
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  @Inject() infoGroupService!: InfoGroupService;
  @Inject() managedListsService!: ManagedListsService;

  ADD_FIELD_BTN = INFO_GROUP_CONSTANTS.BUTTON.ADD_FIELD_BTN_TEXT;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  INFO_GROUP_NAME = INFO_GROUP_CONSTANTS.LABEL.INFO_GROUP_NAME;
  INFO_GROUP_DESC_LABEL = INFO_GROUP_CONSTANTS.LABEL.INFO_GROUP_DESC;
  INFO_GROUP_NAME_PLACEHOLDER =
    INFO_GROUP_CONSTANTS.PLACEHOLDER.INFO_GROUP_NAME;
  INFO_GROUP_DESC_PLACEHOLDER =
    INFO_GROUP_CONSTANTS.PLACEHOLDER.INFO_GROUP_DESC;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  INFO_GROUP_STATE = FORM_CONSTANTS.LABEL.STATE;
  BASIC_INFO_NAME = INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME;
  PREVIEW_BTN = FORM_CONSTANTS.BUTTON.PREVIEW;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;

  cardClass = STYLE_CLASSES.CARD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  priBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  switchClass = STYLE_CLASSES.SWITCH;

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];

  resetFields = 0;
  modalDialogInfoGroup = false;
  clearModel = false;
  modalTitleInfoGroup = "";
  modalTextInfoGroup = "";
  dialogFieldGroup = true;
  dialogPreview = false;
  indexField = -1;
  isEditingGroupField = false;
  infoGroupForm = false;
  groupSchema: FullSchema = FULL_SCHEMA_INITIALIZATION;
  schema: GroupFullSchema = GROUP_SCHEMA_INITIALIZATION;
  phoneSchemaCharged = false;
  phoneTypeList: PhoneSchema[] = [];
  showMoreInfo = true;
  iconsList = ICON_LIST_FIXED;
  schemaCounter = 1;
  showModalAddList = false;
  addFieldsKey = 0;
  errorsName: string[] = [];

  infoGroupFormData: InfoGroupForm = {
    infoGroupName: "",
    infoGroupDescription: "",
    fieldsGroup: [],
    infoGroupState: true
  };

  editComparationStr = "";
  invalidEdit = false;

  mounted() {
    this.resetFields = 1 - this.resetFields;
    this.getIcons();
  }

  @Watch("updateEditing")
  checkEditingInfoGroup() {
    if (this.isEditingInfoGroup) {
      this.dialogFieldGroup = false;
      this.infoGroupFormData.infoGroupName = this.editingInfoGroup.name.trim();
      this.infoGroupFormData.infoGroupDescription = this.editingInfoGroup.description;
      this.infoGroupFormData.fieldsGroup = this.editingInfoGroup.fields;
      this.infoGroupFormData.infoGroupState =
        this.editingInfoGroup.state === FORM_CONSTANTS.STATE.ACTIVE;
      this.phoneSchemaCharged = true;
      this.saveNewFieldOrder();
      this.editComparationStr = JSON.stringify(this.infoGroupFormData);
    } else {
      this.clearData();
    }
  }

  @Watch("infoGroupFormData", { deep: true })
  checkEdit() {
    if (this.isEditingInfoGroup) {
      this.invalidEdit =
        JSON.stringify(this.infoGroupFormData) === this.editComparationStr;
    }
  }
  async getIcons() {
    try {
      const iconResponse = await this.managedListsService.getIconsImages(
        MANAGED_LISTS_TYPES.ICONS
      );

      this.iconsList = (iconResponse.data as Icon[]) || ICON_LIST_FIXED;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async confirmDialog(isSave: boolean) {
    if (isSave) {
      await this.saveInfoGroupModal();
    } else {
      this.$emit(SAVE_INFO_GROUP_EVENTS.CANCEL);
    }
  }

  async handleModalAccept() {
    this.modalDialogInfoGroup = false;

    if (this.modalTitleInfoGroup === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      await this.saveInfoGroup();
    }
  }

  handleModalCancel() {
    this.modalDialogInfoGroup = false;
  }

  handleFieldGroupCancel() {
    this.dialogFieldGroup =
      this.infoGroupFormData.fieldsGroup.length == 0 ?? false;
    this.indexField = -1;
    this.resetFields = 1 - this.resetFields;
    this.isEditingGroupField = false;
  }

  createFieldModal(id: string) {
    this.indexField = -1;
    this.isEditingGroupField = false;
    this.dialogFieldGroup = true;

    Utils.scrollToElement(id, this);
  }

  showPreview() {
    this.dialogPreview = true;
    this.clearModel = true;
  }

  closeModalPreview() {
    this.dialogPreview = false;
  }

  async infoGroupNameExist(): Promise<boolean> {
    const responseData = await this.infoGroupService.checkIfExistByName(
      this.infoGroupFormData.infoGroupName.trim()
    );

    if (responseData.code === Http.NotFound) {
      return false;
    } else if (responseData.code === Http.Found) {
      return true;
    } else {
      throw Error();
    }
  }

  async saveInfoGroupModal(): Promise<void> {
    if (this.infoGroupFormData.fieldsGroup.length === 0) {
      Snackbar.popWarning(FIELD_GROUP_CONSTANTS.MESSAGE.MIN_FIELDS);
      return;
    }

    if (this.isEditingInfoGroup) {
      this.modalTitleInfoGroup = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalTextInfoGroup = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.modalDialogInfoGroup = true;
    } else {
      try {
        const exist: boolean = await this.infoGroupNameExist();

        if (exist) {
          Snackbar.popWarning(
            INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.INFO_GROUP_NAME_EXIST
          );
        } else {
          this.modalTitleInfoGroup = FORM_MESSAGES.SAVE_MODAL.TITLE;
          this.modalTextInfoGroup = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
          this.modalDialogInfoGroup = true;
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
            : INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR;

        this.$emit(SAVE_INFO_GROUP_EVENTS.ERROR);
        Snackbar.popError(errorMessage);
      }
    }
  }

  async saveInfoGroup() {
    this.clearFieldListSchema();

    const state = this.infoGroupFormData.infoGroupState
      ? FORM_CONSTANTS.STATE.ACTIVE
      : FORM_CONSTANTS.STATE.INACTIVE;

    if (this.isEditingInfoGroup) {
      const editingInfoGroup: InfoGroupModel = {
        _key: this.editingInfoGroup._key!,
        changedBy: localStorage.getItem("UID"),
        fields: this.infoGroupFormData.fieldsGroup,
        state: state,
        description: this.infoGroupFormData.infoGroupDescription,
        name: this.editingInfoGroup.name,
        version: this.editingInfoGroup.version
      };

      this.$emit(SAVE_INFO_GROUP_EVENTS.UPDATE, {
        id: this.editingInfoGroup._key!,
        editingInfoGroup
      });
      this.clearData();
    } else {
      const newInfogroup: InfoGroupModel = {
        name: this.infoGroupFormData.infoGroupName.trim(),
        description: this.infoGroupFormData.infoGroupDescription,
        state: state,
        fields: this.infoGroupFormData.fieldsGroup,
        createdBy: localStorage.getItem("UID")
      };
      this.$emit(SAVE_INFO_GROUP_EVENTS.ADD, newInfogroup);
      this.clearData();
    }
  }

  deleteField(field: number) {
    this.schemaCounter++;
    this.dialogFieldGroup = false;
    const foundIndex = this.phoneTypeList.findIndex(
      f => f.slot === `custom-${this.infoGroupFormData.fieldsGroup[field].key}`
    );

    if (foundIndex >= 0) {
      this.phoneTypeList.splice(foundIndex, 1);
    }

    this.infoGroupFormData.fieldsGroup.splice(field, 1);
    if (this.infoGroupFormData.fieldsGroup.length === 0)
      this.dialogFieldGroup = true;
    this.saveNewFieldOrder();
    this.loadSchema();
  }

  updateField(field: number, id: string) {
    this.indexField = field;
    this.isEditingGroupField = true;
    this.dialogFieldGroup = true;

    Utils.scrollToElement(id, this);
  }

  @Watch("infoGroupFormData.fieldsGroup", { deep: true })
  loadSchema() {
    this.groupSchema.required = [];
    this.groupSchema.properties = {};
    this.infoGroupFormData.fieldsGroup.map(field => {
      if (field.visible) {
        this;
        Object.assign(this.groupSchema.properties, {
          [field.key]: field.schema
        });
        field.required ? this.groupSchema.required?.push(field.key) : null;
      }
    });

    if (this.phoneSchemaCharged) {
      this.getPhoneSchema();
      this.phoneSchemaCharged = false;
    }
  }

  getPhoneSchema() {
    const result = this.infoGroupFormData.fieldsGroup.filter(
      field => field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE
    );

    result.forEach(element => {
      this.phoneTypeList.push({
        slot: `custom-${element.key}`,
        title: element.schema.title,
        model: "",
        countryCode: "",
        countryCallingCode: "",
        required: element.required,
        enabled: element.editable,
        formattedNumber: ""
      });
    });
  }

  @Watch("infoGroupFormData.infoGroupName")
  updateNameGroupSchema() {
    Vue.set(
      this.groupSchema,
      "title",
      this.infoGroupFormData.infoGroupName.trim()
    );
  }

  @Watch("infoGroupFormData.infoGroupDescription")
  updateDescriptionGroupSchema() {
    Vue.set(
      this.groupSchema,
      "description",
      this.infoGroupFormData.infoGroupDescription
    );
  }

  saveNewFieldOrder() {
    for (let i = 0; i < this.infoGroupFormData.fieldsGroup.length; i++) {
      const field = this.infoGroupFormData.fieldsGroup[i];
      field.order = i + 1;
      Vue.set(this.infoGroupFormData.fieldsGroup, i, field);
    }
  }

  clearFieldListSchema() {
    this.infoGroupFormData.fieldsGroup.forEach(field => {
      if (field.type === TYPE_FIELDS.LIST) {
        delete field.schema.oneOf;
        delete field.schema.items?.enum;
        delete field.schema.items?.oneOf;
      }
    });
  }

  clearData() {
    this.dialogFieldGroup = true;
    this.infoGroupFormData.infoGroupName = "";
    this.infoGroupFormData.infoGroupDescription = "";
    this.infoGroupFormData.infoGroupState = true;
    this.groupSchema = FULL_SCHEMA_INITIALIZATION;
    this.schema = GROUP_SCHEMA_INITIALIZATION;
    this.resetFields = 1 - this.resetFields;
    this.infoGroupFormData.fieldsGroup = [];
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  addElement() {
    this.showModalAddList = true;
  }

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: COMPONENT_NAME_MODAL.LIST,
      callbackHandleOperation: this.handleOperation
    };
    Utils.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      this.onCloseList();
    }
  }

  onCloseList() {
    this.showModalAddList = false;
  }

  onCloseListModal() {
    this.showModalAddList = false;
    this.addFieldsKey++;
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.INFO_GROUP,
      this.infoGroupFormData.infoGroupName
    );
  }
}
